module.exports = __webpack_public_path__ + "img/about-banner1.50a054d4.jpg";